

import { generateRouteWithId } from "./route-utils";


export const migrateToPathWithId = (redirectionLink: string, idField: string = 'id') => {
  return {
    redirectionPathWithId: `${redirectionLink}/:id`,
    idField
  };
};


export const migrateRoutesToUseParams = (routes: Record<string, string>): Record<string, string> => {
  const updatedRoutes: Record<string, string> = { ...routes };
  
  Object.keys(updatedRoutes).forEach(key => {
    if (
      key.startsWith('VIEW_') || 
      key.startsWith('EDIT_') || 
      key.startsWith('DETAIL_') ||
      key.includes('_VIEW_') || 
      key.includes('_EDIT_') || 
      key.includes('_DETAIL_')
    ) {
      if (!updatedRoutes[key].includes(':')) {
        updatedRoutes[key] = `${updatedRoutes[key]}/:id`;
      }
    }
  });
  
  return updatedRoutes;
};

export const createParameterizedNavigationHandler = (
  navigate: (path: string) => void,
  basePath: string,
  idExtractor: (row: any) => string | number = (row) => row.id
) => {
  return (row: any) => {
    const id = idExtractor(row);
    navigate(generateRouteWithId(basePath, id));
  };
};


export const updateTableConfigForParameterizedNavigation = (
  tableConfig: any,
  pathWithIdField: string,
  idField: string = 'id'
) => {
  const { ...rest } = tableConfig;
  
  return {
    ...rest,
    redirectionPathWithId: pathWithIdField,
    idField
  };
}; 